var map = {
	"./about-slider/a-1.jpg": 1727,
	"./about-slider/a-10.jpg": 7387,
	"./about-slider/a-11.jpg": 4299,
	"./about-slider/a-12.jpg": 8408,
	"./about-slider/a-14.jpg": 6141,
	"./about-slider/a-15.jpg": 9944,
	"./about-slider/a-16.jpg": 736,
	"./about-slider/a-2.jpg": 1298,
	"./about-slider/a-3.jpg": 8238,
	"./about-slider/a-4.jpg": 8243,
	"./about-slider/a-5.jpg": 7048,
	"./about-slider/a-6.jpg": 3906,
	"./about-slider/a-7.jpg": 2649,
	"./about-slider/a-8.jpg": 5543,
	"./about-slider/a-9.jpg": 6327,
	"./about-slider/banner3.jpg": 4536,
	"./about-slider/bannerold.jpg": 5057,
	"./about-slider/familia.jpg": 4847,
	"./about-slider/fur.jpg": 5587,
	"./about-slider/last8.jpg": 6369,
	"./about-slider/logo.png": 8779,
	"./about-slider/one.jpg": 6600,
	"./about-slider/turbo-lights.png": 7257,
	"./about-slider/wiring.jpeg": 9936,
	"./banner/banner1.jpg": 573,
	"./banner/banner3.jpg": 1038,
	"./banner/banner4.jpg": 9454,
	"./banner/banner5.jpg": 9825,
	"./client-logos/1.png": 4810,
	"./client-logos/10.png": 3244,
	"./client-logos/11.png": 9839,
	"./client-logos/12.png": 6214,
	"./client-logos/13.png": 7823,
	"./client-logos/14.png": 2939,
	"./client-logos/15.png": 748,
	"./client-logos/16.png": 1248,
	"./client-logos/17.png": 4899,
	"./client-logos/18.png": 7015,
	"./client-logos/19.png": 4293,
	"./client-logos/2.png": 199,
	"./client-logos/20.png": 7973,
	"./client-logos/21.png": 1545,
	"./client-logos/22.png": 6009,
	"./client-logos/23.png": 6083,
	"./client-logos/24.png": 9405,
	"./client-logos/25.png": 3747,
	"./client-logos/3.png": 3533,
	"./client-logos/4.png": 2543,
	"./client-logos/5.png": 5537,
	"./client-logos/6.png": 4146,
	"./client-logos/7.png": 5762,
	"./client-logos/8.png": 257,
	"./client-logos/9.png": 812,
	"./dealers/20.png": 8454,
	"./dealers/21.png": 2641,
	"./dealers/22.png": 188,
	"./dealers/23.png": 1928,
	"./dealers/24.png": 3198,
	"./dealers/25.png": 2353,
	"./error-404.png": 751,
	"./homepage/10.png": 1700,
	"./homepage/11.png": 8085,
	"./homepage/12.png": 755,
	"./homepage/13.png": 592,
	"./homepage/14.png": 3986,
	"./homepage/15.png": 5346,
	"./homepage/16.png": 6432,
	"./homepage/17.png": 3332,
	"./homepage/18.png": 6031,
	"./homepage/19.png": 6326,
	"./homepage/cabin.jpg": 1798,
	"./homepage/corporate.jpg": 6447,
	"./homepage/creation1.jpg": 2243,
	"./homepage/creation2.jpg": 4363,
	"./homepage/creation2.png": 2179,
	"./homepage/familia.jpg": 1919,
	"./homepage/living.jpg": 5818,
	"./homepage/sofa.jpg": 3092,
	"./homepage/sofa1.webp": 4217,
	"./homepage/sofa2.jpeg": 6195,
	"./images-turbo/2151037591.jpg": 9479,
	"./images-turbo/2151047530.jpg": 5499,
	"./images-turbo/3d-modern-lamp-design (1).jpg": 4704,
	"./images-turbo/3d-modern-lamp-design.jpg": 2234,
	"./images-turbo/3d-modern-lighting-lamp-design - Copy.jpg": 7267,
	"./images-turbo/3d-modern-lighting-lamp-design.jpg": 3215,
	"./images-turbo/5637326c-5ed6-41d2-bbce-15051752f6fb.jpeg": 7227,
	"./images-turbo/8d21dfaf-4c73-4859-80b7-69dbe69e592c.jpeg": 633,
	"./images-turbo/a4226bb5-be6d-494d-84d9-dbdfb930ff10.jpeg": 1550,
	"./images-turbo/banner/1.jpg": 6953,
	"./images-turbo/banner/2.jpg": 4499,
	"./images-turbo/banner/about_banner.png": 3842,
	"./images-turbo/banner/banner.jpg": 2071,
	"./images-turbo/banner/banner2.jpg": 7021,
	"./images-turbo/banner/banner3.jpg": 5104,
	"./images-turbo/banner/banner4.jpg": 1205,
	"./images-turbo/banner/bannerold.jpg": 1453,
	"./images-turbo/banner/banners.png": 5802,
	"./images-turbo/banner/banners2.png": 1286,
	"./images-turbo/banner/banners3.jpg": 2337,
	"./images-turbo/banner/banners33.jpg": 9363,
	"./images-turbo/banner/bedlamp.jpg": 5693,
	"./images-turbo/banner/body1.jpg": 8614,
	"./images-turbo/banner/body2.jpg": 8083,
	"./images-turbo/banner/bradcam.png": 7496,
	"./images-turbo/banner/bradcam2.png": 7264,
	"./images-turbo/banner/bradcam3.png": 6914,
	"./images-turbo/banner/cabin.jpg": 3729,
	"./images-turbo/banner/chand.jpg": 1742,
	"./images-turbo/banner/cheryl-winn-boujnida-jhDof9B6vPY-unsplash.jpg": 2160,
	"./images-turbo/banner/corey-o-brien-YSXxHr2T0_8-unsplash.jpg": 1157,
	"./images-turbo/banner/corporate.jpg": 5519,
	"./images-turbo/banner/douglas-sheppard-9rYfG8sWRVo-unsplash.jpg": 4371,
	"./images-turbo/banner/familia.jpg": 2562,
	"./images-turbo/banner/family.jpg": 894,
	"./images-turbo/banner/five.jpg": 670,
	"./images-turbo/banner/four.jpg": 1694,
	"./images-turbo/banner/hannah-busing-OfeVvdelx3A-unsplash.jpg": 5194,
	"./images-turbo/banner/last1.jpg": 5050,
	"./images-turbo/banner/last2.jpg": 4473,
	"./images-turbo/banner/last3.jpg": 5249,
	"./images-turbo/banner/last4.jpg": 1061,
	"./images-turbo/banner/last5.jpg": 2843,
	"./images-turbo/banner/last6.jpg": 6321,
	"./images-turbo/banner/last7.jpg": 9423,
	"./images-turbo/banner/last8.jpg": 3703,
	"./images-turbo/banner/living.jpg": 3633,
	"./images-turbo/banner/lotus-design-n-print-1FVFzoC8yVM-unsplash.jpg": 285,
	"./images-turbo/banner/michael-soledad-NrR6ByFMBas-unsplash.jpg": 5880,
	"./images-turbo/banner/one.jpg": 4018,
	"./images-turbo/banner/ones.jpg": 8792,
	"./images-turbo/banner/pablo-merchan-montes-wYOPqmtDD0w-unsplash.jpg": 2091,
	"./images-turbo/banner/pexels-curtis-adams-1694007-3773576.jpg": 8114,
	"./images-turbo/banner/pexels-fotoaibe-1643384.jpg": 8195,
	"./images-turbo/banner/pexels-heyho-7587831.jpg": 402,
	"./images-turbo/banner/pexels-mchodakowski-693895.jpg": 2783,
	"./images-turbo/banner/pexels-nicole-michalou-5779173.jpg": 9524,
	"./images-turbo/banner/pexels-pu-ca-adryan-163345030-27920699.jpg": 2216,
	"./images-turbo/banner/pexels-tima-miroshnichenko-6614794.jpg": 5864,
	"./images-turbo/banner/pexels-xiaobao-wei-623559609-17750735.jpg": 3456,
	"./images-turbo/banner/pexels-zion-4597993.jpg": 3192,
	"./images-turbo/banner/phil-desforges-KP7p0-DRGbg-unsplash.jpg": 7737,
	"./images-turbo/banner/sanju-pandita-VInpvvzmWeU-unsplash.jpg": 4716,
	"./images-turbo/banner/six.jpg": 3281,
	"./images-turbo/banner/tom-ritson-syGe7e2gKG0-unsplash.jpg": 8439,
	"./images-turbo/banner/two.jpg": 4564,
	"./images-turbo/banner/twos.jpg": 1518,
	"./images-turbo/chair.jpg": 5961,
	"./images-turbo/chair2.jpg": 4920,
	"./images-turbo/chair3.jpg": 2202,
	"./images-turbo/e3a6dd3f-d0a7-44c9-a222-923645f4a824.jpeg": 4466,
	"./images-turbo/eb6f5c00-8b8a-4124-ab98-19adf1732129.jpeg": 36,
	"./images-turbo/etienne-girardet-NGb91VwnOWY-unsplash.jpg": 6984,
	"./images-turbo/light1.jpg": 1714,
	"./images-turbo/pexels-dropshado-2251248.jpg": 3780,
	"./images-turbo/pexels-heyho-7750093.jpg": 3047,
	"./images-turbo/pexels-jonathanborba-28059306.jpg": 5274,
	"./images-turbo/pexels-mike-van-schoonderwalt-1884800-5511103.jpg": 9934,
	"./images-turbo/pexels-sharrrrrk-12610912.jpg": 6018,
	"./images-turbo/sofa-banner.jpg": 1054,
	"./images-turbo/sofa-banner2.jpg": 1018,
	"./images-turbo/sofa-regular.jpg": 2240,
	"./images-turbo/sofa.jpg": 4831,
	"./images-turbo/sofa2.jpg": 4621,
	"./images-turbo/sofa3.jpg": 2671,
	"./images-turbo/sofa4.jpg": 9023,
	"./images-turbo/sofa5.jpg": 9197,
	"./images-turbo/sofa6.jpg": 9501,
	"./logo/turbo-logo-bw-transparent.png": 3074,
	"./logo/turbo-logo-bw.jpg": 8526,
	"./logo/turbo-logo-color-transparent-bg.png": 5661,
	"./logo/turbo-logo-color.jpg": 2233,
	"./main-slider/slider2/slide1.jpg": 5610,
	"./main-slider/slider2/slide2.jpg": 7921,
	"./main-slider/slider2/slide3.jpg": 4355,
	"./marker.png": 651,
	"./newloader.gif": 4608,
	"./projects/apollo/a1.jpeg": 46,
	"./projects/apollo/a2.jpeg": 2945,
	"./projects/apollo/a3.jpeg": 1493,
	"./projects/axtria/1.jpeg": 2995,
	"./projects/axtria/2.jpeg": 7185,
	"./projects/axtria/3.jpeg": 5436,
	"./projects/axtria/4.jpeg": 6511,
	"./projects/axtria/5.jpeg": 1519,
	"./projects/axtria/6.jpeg": 454,
	"./projects/axtria/7.jpeg": 4683,
	"./projects/axtria/8.jpeg": 1436,
	"./projects/ey/1.jpeg": 6536,
	"./projects/ibr/1.jpeg": 3369,
	"./projects/ibr/2.jpeg": 2715,
	"./projects/ibr/3.jpeg": 8296,
	"./projects/piramal/1.jpeg": 4261,
	"./projects/piramal/10.jpeg": 3463,
	"./projects/piramal/11.jpeg": 8964,
	"./projects/piramal/12.jpeg": 7872,
	"./projects/piramal/2.jpeg": 6412,
	"./projects/piramal/3.jpeg": 195,
	"./projects/piramal/4.jpeg": 2316,
	"./projects/piramal/5.jpeg": 7516,
	"./projects/piramal/6.jpeg": 1474,
	"./projects/piramal/7.jpeg": 4150,
	"./projects/piramal/8.jpeg": 6346,
	"./projects/piramal/9.jpeg": 253,
	"./projects/saint/1.jpeg": 1091,
	"./projects/saint/2.jpeg": 8638,
	"./projects/saint/3.jpeg": 2092,
	"./projects/saint/4.jpeg": 3674,
	"./projects/saint/5.jpeg": 5837,
	"./projects/wiprowater/1.jpeg": 8200,
	"./projects/wiprowater/2.jpeg": 6345,
	"./projects/wiprowater/3.jpeg": 3222,
	"./projects/wiprowater/4.jpeg": 8646,
	"./projects/wiprowater/5.jpeg": 9550,
	"./switches/products/1.png": 3880,
	"./switches/products/15.png": 2987,
	"./switches/products/16.png": 7877,
	"./switches/products/2.png": 1981,
	"./switches/products/3.png": 7582,
	"./switches/products/4.png": 3191,
	"./switches/products/WhatsApp Image 2025-03-15 at 2.04.37 PM.jpeg": 7766,
	"./switches/products/a-1.png": 9484,
	"./switches/products/a-2.png": 9428,
	"./switches/products/a-3.png": 9871,
	"./switches/products/a-4.png": 2128,
	"./switches/products/a1.png": 9466,
	"./switches/products/a2.png": 7102,
	"./switches/products/about1.jpg": 3056,
	"./switches/products/aboutfinal.jpeg": 347,
	"./switches/products/aboutfinal.jpg": 8793,
	"./switches/products/an.jpg": 4585,
	"./switches/products/anchorlogo.png": 2109,
	"./switches/products/ar.jpg": 9837,
	"./switches/products/ar.png": 1179,
	"./switches/products/bell-push.png": 1177,
	"./switches/products/dB.png": 7798,
	"./switches/products/dwb.png": 4897,
	"./switches/products/edge-smart-panel.png": 4607,
	"./switches/products/enq.png": 2874,
	"./switches/products/enquire.png": 2196,
	"./switches/products/footer.avif": 1410,
	"./switches/products/g1.png": 1584,
	"./switches/products/g2.png": 8796,
	"./switches/products/g3.png": 1959,
	"./switches/products/g4.png": 7907,
	"./switches/products/g5.png": 2073,
	"./switches/products/g6.png": 5208,
	"./switches/products/g7.png": 8959,
	"./switches/products/g8.png": 4974,
	"./switches/products/g9.png": 6038,
	"./switches/products/l1.jpeg": 3609,
	"./switches/products/l1.jpg": 9747,
	"./switches/products/l1.png": 5160,
	"./switches/products/l1.webp": 7985,
	"./switches/products/l10.png": 8189,
	"./switches/products/l11.png": 5722,
	"./switches/products/l12.png": 8876,
	"./switches/products/l13.png": 4478,
	"./switches/products/l14.png": 1946,
	"./switches/products/l15.png": 4778,
	"./switches/products/l16.png": 5911,
	"./switches/products/l17.png": 9300,
	"./switches/products/l18.png": 6292,
	"./switches/products/l19.png": 2324,
	"./switches/products/l2.png": 6734,
	"./switches/products/l20.png": 380,
	"./switches/products/l21.png": 6456,
	"./switches/products/l3.png": 640,
	"./switches/products/l4.png": 5288,
	"./switches/products/l5.png": 323,
	"./switches/products/l6.png": 835,
	"./switches/products/l7.png": 7873,
	"./switches/products/l8.png": 8286,
	"./switches/products/l9.png": 5947,
	"./switches/products/light.jpeg": 8354,
	"./switches/products/light.jpg": 8773,
	"./switches/products/lightingbanner.png": 3394,
	"./switches/products/logo.jpg": 8820,
	"./switches/products/luxe-fan-regulator.png": 5473,
	"./switches/products/penta-flat.png": 2961,
	"./switches/products/polycab.png": 3637,
	"./switches/products/pro.jpg": 2808,
	"./switches/products/pro.png": 8132,
	"./switches/products/re.png": 7397,
	"./switches/products/roma-classic.jpg": 4889,
	"./switches/products/roma.png": 1110,
	"./switches/products/seating.jpg": 9420,
	"./switches/products/ss1.png": 4737,
	"./switches/products/ss10.png": 6722,
	"./switches/products/ss11.png": 6608,
	"./switches/products/ss12.png": 3829,
	"./switches/products/ss13.png": 6863,
	"./switches/products/ss14.png": 4829,
	"./switches/products/ss2.png": 2190,
	"./switches/products/ss3.png": 5098,
	"./switches/products/ss4.png": 545,
	"./switches/products/ss5.png": 2839,
	"./switches/products/ss6.png": 1345,
	"./switches/products/ss7.png": 5816,
	"./switches/products/ss8.png": 2707,
	"./switches/products/ss9.png": 7880,
	"./switches/products/ssl1.png": 9790,
	"./switches/products/ssl2.png": 7375,
	"./switches/products/swi.jpg": 6632,
	"./switches/products/swi.png": 4782,
	"./switches/products/swi.webp": 329,
	"./switches/products/switched-socket.png": 5968,
	"./switches/products/switches-banner.png": 415,
	"./switches/products/turbo-lights.png": 925,
	"./switches/products/turbodb.png": 4171,
	"./switches/products/w1.png": 6449,
	"./switches/products/w10.png": 4751,
	"./switches/products/w11.png": 6243,
	"./switches/products/w12.png": 7220,
	"./switches/products/w2.png": 1697,
	"./switches/products/w3.png": 2112,
	"./switches/products/w4.png": 5428,
	"./switches/products/w5.png": 2549,
	"./switches/products/w6.png": 2493,
	"./switches/products/w7.png": 2473,
	"./switches/products/w8.png": 2885,
	"./switches/products/w9.png": 9994,
	"./switches/products/wbp.png": 2253,
	"./switches/products/wbp1.png": 9815,
	"./switches/products/wires.png": 752,
	"./switches/products/wnw.jpg": 8450,
	"./switches/products/wnw.png": 7412,
	"./switches/products/wnw1.png": 2814,
	"./switches/products/wnw2.png": 1525,
	"./switches/products/wp1.png": 1588,
	"./switches/products/wp2.png": 4752,
	"./switches/products/wp3.png": 3618,
	"./switches/products/wp4.png": 1197,
	"./switches/products/wp5.png": 6627,
	"./switches/products/wp6.png": 6351,
	"./switches/products/wp7.png": 6749,
	"./switches/products/wp8.png": 9457,
	"./switches/products/wpl.png": 2845
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;